import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultComponent } from './result.component';
import { SharedComponentsModule } from '.././../shared-components/shared-components.module';
import { RouterModule } from '@angular/router';
import { CeiboShare } from 'ng2-social-share';
import { NgModel, FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    RouterModule,
    FormsModule
  ],
  exports: [
    ResultComponent,
    CeiboShare
  ],
  declarations: [
    ResultComponent,
    CeiboShare
  ]
})
export class ResultModule { }



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/views/result/result.module.ts